
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/partners",
      function () {
        return require("private-next-pages/living/partners.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/partners"])
      });
    }
  